import Header from '@/fragments/header/Header'
import Sidebar from '@/fragments/sidebar/Sidebar'
import Footer from '@/fragments/footer/Footer'
import Toaster from '@/fragments/toaster/Toaster'
import Confirm from '@/fragments/dialogs/confirm/Confirm'
import Info from '@/fragments/dialogs/info/Info'
import MainMenu from '@/common/main-menu'

export default {
  data () {
    return {
      title: 'CycleAI | Route Planner',
      showLoading: false 
    }
  },
  name: 'ORSWebClientApp',
  components: {
    appHeader: Header,
    appSidebar: Sidebar,
    appFooter: Footer,
    appToaster: Toaster,
    appConfirm: Confirm,
    appInfo: Info
  },
  created () {
    // This is the first and main component rendered when the app
    // is loaded. Therefore, as soon as it is created, we store
    // a reference to the root Vue component in the store
    // so that other component can easily access it
    this.$store.commit('mainAppInstanceRef', this.$root)

    // Register the listener for the showLoading and 
    // titleChanged events
    this.eventBus.$on('showLoading', (value) => {
      this.showLoading = value
    })
    this.eventBus.$on('titleChanged', (title) => {
      this.title = title
    })
  },
  mounted() {
    MainMenu.adjustMenu()  
  },
}
